var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import orderBy from 'lodash/orderBy';
import { isNullOrEmpty } from '@pcty/utils';
/**
 * Sorts a dataset
 *
 * @category Sorting
 * @template T=unknown
 * @param {T[]} data - The dataset to sort
 * @param {TablePageConfigSorting} sorting - The sorting config object shaped like { keys, direction }
 * @returns {T[]} - The sorted dataset
 * @example
 * import { sortData } from '@citrus/data-table';
 * import { sortReduceString } from '@pcty/utils';
 *
 * const data = [{ id: 1, hero: 'Batman' }, { id: 2, hero: 'Superman' }];
 * const sorting = {
 *   column: 'hero',
 *   direction: 'default',
 *   sort: [sortReduceString('hero')],
 * };
 *
 * sortData(data, sorting);
 */
export default (function (data, sorting) {
    if (isNullOrEmpty.any(sorting === null || sorting === void 0 ? void 0 : sorting.sort, sorting === null || sorting === void 0 ? void 0 : sorting.direction))
        return data;
    var keys = [];
    var direction = [];
    for (var _i = 0, _a = sorting.sort; _i < _a.length; _i++) {
        var item = _a[_i];
        switch (typeof item) {
            case 'function':
            case 'string':
            default:
                keys = __spreadArray(__spreadArray([], keys, true), [item], false);
                direction = __spreadArray(__spreadArray([], direction, true), [sorting.direction === 'default' ? 'asc' : 'desc'], false);
                break;
            case 'object':
                keys = __spreadArray(__spreadArray([], keys, true), [item.key], false);
                direction = __spreadArray(__spreadArray([], direction, true), [
                    // eslint-disable-next-line no-nested-ternary
                    sorting.direction === 'default' ? item.default : item.default === 'asc' ? 'desc' : 'asc',
                ], false);
                break;
        }
    }
    return orderBy(data, keys, direction);
});
